import angular from 'angular';
import loansAmountSimulationComponent from './loansAmountSimulation.component';
import loansAmountSimulationErrors from './loansAmountSimulationErrors/loansAmountSimulationErrors';

let loansAmountSimulationModule = angular.module('loansAmountSimulation', [
  loansAmountSimulationErrors
])

.component('loansAmountSimulation', loansAmountSimulationComponent)

.name;

export default loansAmountSimulationModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansAmountSimulation/loansAmountSimulation.js